import { AiAssistantSubmissionChatMessage } from "types/aiAssistant";

export const isAiAssistantSubmissionChatMessage = (
  message: string | AiAssistantSubmissionChatMessage,
): message is AiAssistantSubmissionChatMessage => {
  return typeof message === "object" && "type" in message;
};
